module.exports = __webpack_public_path__ + "media/images/flags/mv-cd1f55b02ca2643c3f9930941074ab0f.svg";